
function isSearchMeta(list, path) {
	let text = ''
	list.some(q => {
		if (q.url == path) {
      if (q.children.length > 0) {
				return text = isSearchMeta(q.children, path)
			} else {
        return text = q.resourcesName
      }
		} else {
			if (q.children.length > 0) {
				return text = isSearchMeta(q.children, path)
			}
		}
		
	})
	return text
	
}
import { mixin } from "@/components/libs/mixs.js";
export function taxHeaderSet(to, form, callback,router={}) {
	// 服务请求回来的路由
	let menuObj = JSON.parse(window.LS.get("SY") || '{}')
	let menuList = menuObj.menu || [];
	let meta = Object.assign({},  to.meta)
	meta.text = isSearchMeta(menuList, to.path) || meta.text
	console.log(menuList);
	// 财税部分
	let str = callback(to, form)
	if (to.meta.store && !to.meta.taxNoShow) {
		// 财税部分
		var localData = window.LS.get("taxList") || '[]';
		localData = JSON.parse(localData)
		var ifPush = localData.findIndex(function(item) {
			return item.path == to.path
			// return item.fullPath == to.fullPath
		});
		if (ifPush == -1) { //不存在就添加
			if (localData.length >= 8) localData.shift();

			let rout = {}
			rout.fullPath = to.fullPath
			rout.path = to.path
			rout.meta = meta
			rout.crumb = str
			localData.push(rout);
		} else { //存在就替换
      if(to.fullPath !== localData[ifPush].fullPath){
        Promise.resolve().then(mixin.methods.toClearKeepAlive(to.path,router));
      }
			localData.splice(ifPush, 1, {
				fullPath: to.fullPath,
				crumb: str,
				path: to.path,
				meta: meta
			})
		}
		window.LS.set("taxList", JSON.stringify(localData));
	} else if (to.meta.noStore) {} else if (!to.meta.store) {
		let localData = window.LS.get("normalList") || '[]';
		localData = JSON.parse(localData);
		let ifPush = localData.findIndex(function(item) {
			return item.path == to.path
			// return item.fullPath == to.fullPath
		});
		if (ifPush == -1) { //不存在就添加
			if (localData.length >= 8) {
				localData.shift();
			}
			let rout = {}
			rout.fullPath = to.fullPath
			rout.path = to.path
			rout.crumb = str
			rout.meta = meta
			localData.push(rout);
		} else { //存在就替换
      if(to.fullPath !== localData[ifPush].fullPath){
        Promise.resolve().then(mixin.methods.toClearKeepAlive(to.path,router));
      }
			localData.splice(ifPush, 1, {
				fullPath: to.fullPath,
				crumb: str,
				path: to.path,
				meta: meta
			})
		}
		window.LS.set("normalList", JSON.stringify(localData));
	}
}
